import { RefundRequest } from "../model/refundRequest/RefundRequest";

export class RefundPostCommand{
    refundView:RefundRequest;

    constructor(refundView:RefundRequest){
        this.refundView = refundView;
    }
}